import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CheckIn from './checkIn';
import {
  createMeeting,
  getMeetingById,
  updateMeeting,
  getInvoiceList,
  saveCheckinForMeeting,
} from 'services/redux/brandActivtion/meetings/action';

import { getCorpPocList } from 'services/redux/brandActivtion/corporateClient/action';
import { getCorpClientList } from 'services/redux/brandActivtion/corporateClient/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';


const mapStateToProps = (state) => ({
  corpClientList: state.CorpClientReducer.corpClientList,
  corpClientPoc: state.CorpClientReducer.corpClientPoc,
});


const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createMeeting,
      getMeetingById,
      updateMeeting,
      getCorpClientList,
      documentUploadUrl,
      getCorpPocList,
      getInvoiceList,
      documentUploadUrlPublic,
      saveCheckinForMeeting
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CheckIn);
